/*
  This file is a copy of https://github.com/launchdarkly/vue-client-sdk/blob/6cd132d69a0ff68e41c5b73ae481ab93fb13e3c1/src/getLDFlag.ts
  since the type FlagRef<T> and the const getLDFlag are not exported from the package.
 */
import { onBeforeUnmount, readonly, ref, type Ref } from 'vue'
import type { LDClient } from 'launchdarkly-js-client-sdk'

export type FlagRef<T> = Readonly<Ref<T>>

export const getLDFlag = (ldReady: Ref<boolean>, $ldClient: LDClient, enableStreaming = true) => {
  return function ldFlag<T>(flagKey: string, defaultFlagValue?: T): FlagRef<T> {
    const isLdReady = ldReady.value
    const flagValue = isLdReady ? $ldClient.variation(flagKey, defaultFlagValue) : defaultFlagValue
    const flagRef = ref(flagValue)
    if (!enableStreaming) {
      return readonly(flagRef)
    }

    const updateFlagRef = (newFlagValue: unknown) => (flagRef.value = newFlagValue)
    $ldClient.on(`change:${flagKey}`, updateFlagRef)
    onBeforeUnmount(() => $ldClient.off(`change:${flagKey}`, updateFlagRef))
    if (!isLdReady) {
      $ldClient.on('ready', () => updateFlagRef($ldClient.variation(flagKey, flagRef.value)))
    }
    return readonly(flagRef)
  }
}
